module.exports = __webpack_public_path__ + "static/img/img_hjjc.8d0f2d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_hjjc.png
// module id = ++Rc
// module chunks = 0